import { StyleSheet } from 'react-native';
import { CELEBRATION_COLORS } from '../../constants/celebrations.constants';

// Compact enough that the cluster fits the standard ~60px web / ~44px native header row
// without growing it — the LV pill overlaps the ring's bottom rather than hanging below.
export const XP_RING_SIZE = 44;
export const XP_RING_STROKE = 3;
export const XP_RING_RADIUS = (XP_RING_SIZE - XP_RING_STROKE) / 2;
export const XP_RING_AVATAR_INSET = 5;
export const XP_RING_CIRCUMFERENCE = 2 * Math.PI * XP_RING_RADIUS;

// Colors are design constants from the header design file (variant 1a), not theme-derived
export const getXpHeaderClusterStyles = () =>
  StyleSheet.create({
    cluster: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 10,
    },
    ringBlock: {
      width: XP_RING_SIZE,
      // The LV pill overlaps the ring's bottom edge (see levelPill), so the block is just the
      // ring — no extra height, keeping the header row at its normal height.
      height: XP_RING_SIZE,
    },
    ringSvg: {
      position: 'absolute',
      left: 0,
      top: 0,
      transform: [{ rotate: '-90deg' }],
    },
    avatarWrap: {
      position: 'absolute',
      left: XP_RING_AVATAR_INSET,
      top: XP_RING_AVATAR_INSET,
      width: XP_RING_SIZE - XP_RING_AVATAR_INSET * 2,
      height: XP_RING_SIZE - XP_RING_AVATAR_INSET * 2,
      borderRadius: 999,
      overflow: 'hidden',
      backgroundColor: CELEBRATION_COLORS.SURFACE,
      alignItems: 'center',
      justifyContent: 'center',
    },
    levelPill: {
      position: 'absolute',
      alignSelf: 'center',
      // Overlap the ring's bottom edge instead of hanging below it (no added header height).
      bottom: -2,
      backgroundColor: CELEBRATION_COLORS.PURPLE,
      borderRadius: 999,
      paddingVertical: 1,
      paddingHorizontal: 6,
      borderWidth: 1.5,
      borderColor: CELEBRATION_COLORS.SURFACE,
    },
    levelPillText: {
      fontSize: 9,
      fontWeight: '800',
      color: CELEBRATION_COLORS.INK,
    },
    rankBlock: {
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: 0,
    },
    rankBadge: {
      // Match the avatar/ring footprint so the badge reads as the same size as the avatar.
      width: XP_RING_SIZE,
      height: XP_RING_SIZE,
    },
    pressed: {
      opacity: 0.65,
    },
    hovered: {
      opacity: 0.85,
    },
  });
